import React, { useMemo } from 'react';
import styles from './simpleStat.module.scss';
import { useCountUp } from '../../../hooks/hooks';
import { H1, H2, H3, H4, H5, H6, StatHeading } from '../../../text';

type SimpleStatProps = {
  count: number,
  title: string,
  size?: 1 | 2 | 3 | 4 | 5 | 6 | undefined | null,
  suffix?: string | null
}

/**
 * Simple stat
 * @param {number} props.count
 * @param {string} props.title
 * @param {number} [props.size]
 * @param {string} [props.suffix]
 * @param {React.ReactNode} props.children
 * @returns {JSX.Element}
 */
const SimpleStat: React.FC<SimpleStatProps> = ({ count, title, size = 3, suffix = null }) => {
  const displayCount = useCountUp({
    to: count,
    duration: 2,
    ease: 'none'
  });

  const displayCountWithSuffix = useMemo(() => `${displayCount}${suffix ? suffix : ''}`, [displayCount, suffix]);

  return (
    <div className={styles.simpleStat}>
      <StatHeading>{title}</StatHeading>
      <div className={styles.count}>
        {
          [
            <H1>{displayCountWithSuffix}</H1>,
            <H2>{displayCountWithSuffix}</H2>,
            <H3>{displayCountWithSuffix}</H3>,
            <H4>{displayCountWithSuffix}</H4>,
            <H5>{displayCountWithSuffix}</H5>,
            <H6>{displayCountWithSuffix}</H6>
          ][size ? size - 1 : 3]
        }
      </div>
    </div>
  );
}

export default React.memo(SimpleStat, (prevProps, nextProps) => prevProps.count === nextProps.count);